import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { useStyles } from './styles';

export interface BrandHeaderProps {
  brandName: string;
  logoUrl: string;
}

export const BrandHeader: FC<BrandHeaderProps> = ({ brandName, logoUrl }) => {
  const styles = useStyles();
  const intl = useIntl();

  return (
    <img
      className={styles.brandLogo}
      alt={intl.formatMessage(
        {
          defaultMessage: '{brandName} logo',
          description: 'Brand logo inside of the header',
        },
        { brandName },
      )}
      src={logoUrl}
    />
  );
};
